import {purgeTextures,validPurgeRecipe,validPurgeAssets} from '../vfx-purge-profile';
import {createPurchasedPurgeSpiral} from '../../encounter-creation-engine/ft3d-purchased-purge-spiral';
import type {VfxFamily} from '../vfx-family-registry';

/** Compatibility uses the same renderer and saved parameters; no shader, seed or motion conversion. */
export const spellArtCleanseFamily:VfxFamily = {
  preview:{bodyReachScale:.72,topScale:1.5},
  id:'cleanse',legacyContactStyle:'purchased-purge-spiral',programPrefix:'Cleanse purge ',
  diagnostics:(recipe,path)=>validPurgeRecipe(recipe)?[]:[{
    code:recipe.contactStyle==='family'?'vfx:family-cleanse':'vfx:purchased-purge-spiral',
    path:`${path}.contactStyle`,message:'Invalid cleanse authored fields',
  }],
  textures:recipe=>purgeTextures(recipe.purgeVariant),
  validAssets:(assets,recipe)=>validPurgeAssets(assets,recipe.purgeVariant),
  programKey:recipe=>recipe.purgeVariant?'variants':'holy',
  create:(T,world,body,maps,target,recipe)=>createPurchasedPurgeSpiral(T,world,body.visualRoot,body.position,body.height,
    maps,target,recipe.flareWarmth??0,recipe.purgeVariant,recipe.anchor==='caster'),
};
